import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateUploadFileFormField(
  params: FormFieldGenerationParams<'uploadFile'>,
): PartialPropsOf<'uploadFile'> {
  let props: PartialPropsOf<'uploadFile'> = applyPropsPatch(params.props, {
    content: {
      title: { enabled: true },
      options: { multiple: params.inputData.column.multipleValues || false },
    },
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, { content: { button: { readonly: true } } });
  }

  return props;
}
